var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagein"},_vm._l((_vm.list),function(n){return _c('div',{key:n.id},[_c('img',{attrs:{"src":require("../assets/" + n + ".jpg")}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }